import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/sections/header";
import { Hero } from "@/components/sections/hero";
import { MarqueeBand } from "@/components/sections/marquee-band";
import { Features } from "@/components/sections/features";
import { FlowShowcase } from "@/components/sections/flow/flow-showcase";
import { Stats } from "@/components/sections/stats";
import { WaitlistForm } from "@/components/sections/waitlist-form";
import { CTA } from "@/components/sections/cta";
import { Footer } from "@/components/sections/footer";
import { Language } from "@linqx/i18n";
import { seo } from "@/lib/seo";

/**
 * Home is a fully interactive WebGL + scroll experience. Its <head> meta is
 * managed at runtime by <HeadContent />; the static baseline in index.html
 * covers non-JS social scrapers.
 */
export const Route = createFileRoute("/")({
  head: () => ({
    meta: seo({
      title: Language.getKey("landing_meta_home_title"),
      description: Language.getKey("landing_meta_home_description"),
      url: "https://getlinqx.com/",
    }),
  }),
  component: Home,
});

function Home() {
  return (
    <main className="min-h-screen bg-background overflow-x-clip">
      <Header />
      <Hero />
      <MarqueeBand />
      <Features />
      <FlowShowcase />
      <Stats />
      <WaitlistForm />
      <CTA />
      <Footer />
    </main>
  );
}
